// TODO refactor!
import { Component, Input } from '@angular/core';
import { IPracaDyplomowaStep } from '@interfaces/dyplomowanie/praca-dyplomowa.interface';
import { StatusPraktykiStudentaDto as StatusPraktykiStudentaDtoPlatformaAdministracyjna } from '@interfaces/praktyki/platforma-administracyjna/praktyki-studentow/status-praktyki-studenta.interface';
import { StatusPraktykiStudentaDto as StatusPraktykiStudentaDtoPlatformaPracownikaNaukowego } from '@interfaces/praktyki/platforma-pracownika-naukowego/praktyki-studentow/status-praktyki-studenta.interface';
import { StatusPraktykiStudentaDto as StatusPraktykiStudentaDtoPlatformaStudenta } from '@interfaces/praktyki/platforma-studenta/praktyka-studenta.interface';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
})
export class ProgressIndicatorComponent {
  @Input() steps:
    | IPracaDyplomowaStep[]
    | StatusPraktykiStudentaDtoPlatformaStudenta[]
    | StatusPraktykiStudentaDtoPlatformaPracownikaNaukowego[]
    | StatusPraktykiStudentaDtoPlatformaAdministracyjna[] = [];
}
